<template>
  <div v-loading="loading">
    <img :src="panelImage" :class="$store.getters.hOrV + ' h350'" alt="" />
   
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PanelImage",
  data() {
    return {
      panelImage: 'images/empty.png',
      loading: false
    };
  },
  watch: {
    '$store.state.artwork.format' : {
      handler() {
        this.getPreviewImage()
      },
      immediate: true,
    },
    '$store.state.artwork.frameColor' : {
      handler() {
        this.getPreviewImage()
      },
    },
    '$store.state.artwork.keyColor' : {
      handler() {
        this.getPreviewImage()
      },
    },
    '$store.state.artwork.buttonFormat' : {
      handler() {
        this.getPreviewImage()
      },
    },
    '$store.state.artwork.leftSideLeftButton' : {
      handler() {
        this.getPreviewImage()
      },
    },
    '$store.state.artwork.leftSideRightButton' : {
      handler() {
        this.getPreviewImage()
      },
    },
    '$store.state.artwork.rightSideLeftButton' : {
      handler() {
        this.getPreviewImage()
      },
    },
    '$store.state.artwork.rightSideRightButton' : {
      handler() {
        this.getPreviewImage()
      },
    },
    '$store.state.artwork.tripleRightSideLeftButton' : {
      handler() {
        this.getPreviewImage()
      },
    },
    '$store.state.artwork.tripleRightSideRightButton' : {
      handler() {
        this.getPreviewImage()
      },
    },
  },
  methods: {
    async getPreviewImage() {
      this.loading = true;
      this.$emit('image_loading');
      let artwork = Object.assign({}, this.$store.state.artwork);
      artwork.img = "";
      let response = await axios.post("/compose", { artwork: artwork }, { responseType: 'blob' })
      this.panelImage = URL.createObjectURL(response.data);
      this.$emit('image_loaded');
      this.loading = false;
    },  
  },
};
</script>
